export default __webpack_public_path__ + "static/traffic-lead-4-1ae8aac189a017f0e6f25d9cab6df76c.jpg";